import { useEffect } from 'react'
import { useMFEStore } from '../mfe/hooks'
import MFEBus from '../mfe/MFEBus'

/**
 * ThemeProvider — reads `theme` from MFEStore and applies
 * `data-theme="light|dark"` to <html>, persists to localStorage,
 * and emits `theme:change` on the MFEBus.
 *
 * Mount order: placed before all MFEs so the correct theme is set
 * before any component renders, preventing a flash of the wrong theme.
 */
export function ThemeProvider() {
  const [store, setStore] = useMFEStore()

  /* detect preferred theme on first mount */
  useEffect(() => {
    const saved     = localStorage.getItem('dp-theme')
    const preferred = window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
    setStore({ theme: saved || preferred })
  }, [])

  /* apply data-theme attribute + persist whenever theme changes */
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', store.theme)
    localStorage.setItem('dp-theme', store.theme)
    MFEBus.emit('theme:change', { theme: store.theme })
  }, [store.theme])

  return null
}
